var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-ancestry-bubbles" },
    [
      _vm.showGlobalStatus
        ? _c("div", { staticClass: "vks-ancestry-bubbles-head" }, [
            _vm.loading
              ? _c("span", { staticClass: "vks-ancestry-bubbles-status" }, [
                  _vm._v("Checking availability…"),
                ])
              : _vm.error
              ? _c(
                  "span",
                  { staticClass: "vks-ancestry-bubbles-status is-error" },
                  [_vm._v(_vm._s(_vm.error))]
                )
              : _c("span", { staticClass: "vks-ancestry-bubbles-status" }, [
                  _vm._v(
                    " No ancestry-specific association data for this locus. "
                  ),
                ]),
          ])
        : _vm._e(),
      _vm._l(_vm.resolvedGroups, function (group) {
        return _c(
          "div",
          {
            key: group.phenotype || "primary",
            staticClass: "vks-ancestry-bubble-group",
          },
          [
            _vm.showGroupHeaders
              ? _c("h5", { staticClass: "vks-ancestry-bubble-group-title" }, [
                  _vm._v(" " + _vm._s(group.label) + " "),
                ])
              : _vm._e(),
            group.loading || group.error || !group.bubbles.length
              ? _c("div", { staticClass: "vks-ancestry-bubbles-head" }, [
                  group.loading
                    ? _c(
                        "span",
                        { staticClass: "vks-ancestry-bubbles-status" },
                        [_vm._v(" Checking availability… ")]
                      )
                    : group.error
                    ? _c(
                        "span",
                        { staticClass: "vks-ancestry-bubbles-status is-error" },
                        [_vm._v(" " + _vm._s(group.error) + " ")]
                      )
                    : _c(
                        "span",
                        { staticClass: "vks-ancestry-bubbles-status" },
                        [
                          _vm._v(" No ancestry-specific association data "),
                          _vm.showGroupHeaders
                            ? [_vm._v(" for " + _vm._s(group.label) + " ")]
                            : _vm._e(),
                          _vm._v(" . "),
                        ],
                        2
                      ),
                ])
              : _vm._e(),
            group.bubbles.length
              ? _c(
                  "div",
                  {
                    staticClass: "vks-ancestry-bubbles-list",
                    attrs: {
                      role: "group",
                      "aria-label": `Available ancestries for ${group.label}`,
                    },
                  },
                  _vm._l(group.bubbles, function (bubble) {
                    return _c(
                      "button",
                      {
                        key: `${group.phenotype}-${bubble.code}`,
                        staticClass: "vks-ancestry-bubble",
                        class: {
                          "is-active": _vm.isActive(group, bubble.code),
                          "is-primary": _vm.isPrimary(bubble.code),
                          "is-loading": _vm.isSeriesLoading(group, bubble.code),
                        },
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.isActive(group, bubble.code)
                            ? "true"
                            : "false",
                          disabled:
                            _vm.isPrimary(bubble.code) ||
                            _vm.isSeriesLoading(group, bubble.code),
                          title: _vm.bubbleTitle(group, bubble),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onToggle(group, bubble.code)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "vks-ancestry-bubble-label" },
                          [_vm._v(_vm._s(bubble.label))]
                        ),
                        _c(
                          "span",
                          { staticClass: "vks-ancestry-bubble-code" },
                          [_vm._v(_vm._s(bubble.code))]
                        ),
                        bubble.count != null
                          ? _c(
                              "span",
                              { staticClass: "vks-ancestry-bubble-count" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatCount(bubble.count)) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }